import { useState, useEffect } from 'react'
import ContactForm from '../components/ContactForm'
import { updatePageSEO } from '../lib/seo'

export default function About() {
  const [pageData, setPageData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    window.scrollTo(0, 0)

    const fetchPage = async () => {
      try {
        const res = await fetch('https://api.dev.auxo.dk/public/by-slug/om-os')
        if (res.ok) {
          const data = await res.json()
          setPageData(data)
          if (data.meta_title || data.meta_description) {
            updatePageSEO(data.meta_title, data.meta_description)
          }
        }
      } catch (err) {
        console.error('Error fetching about page:', err)
      } finally {
        setLoading(false)
      }
    }

    fetchPage()
  }, [])

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center bg-white">
        <div className="text-center space-y-4">
          <i className="fa-solid fa-spinner animate-spin text-4xl text-brand-orange"></i>
          <p className="text-slate-500 font-medium">Henter indhold...</p>
        </div>
      </div>
    )
  }

  if (!pageData) return null

  return (
    <div className="bg-white">
      {/* Page Header */}
      <section className="bg-[#111111] text-white py-20 relative overflow-hidden border-b border-[#222222]">
        <div className="absolute inset-0 opacity-15">
          <img
            src="https://assets.auxodev.dk/cdn-cgi/image/width=1920,quality=50,format=auto/assets/c68264d9-2499-44ef-9e49-6b5cd7a6c3b2/4-53.jpg"
            alt="Om BAW Byg"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative mx-auto max-w-7xl px-6 md:px-12 text-left space-y-4">
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-brand-orange block">HVEM ER VI?</span>
          <h1 className="text-3xl md:text-5xl font-extrabold tracking-tight uppercase">Om os</h1>
          <p className="text-slate-300 max-w-2xl text-sm md:text-base leading-relaxed">
            Læs mere om firmaet og hvad vi sørger for, når vi hjælper dig med din næste tømreropgave.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-24 mx-auto max-w-7xl px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-16 items-start bg-white">
        {/* Content Column */}
        <div className="lg:col-span-7 space-y-6">
          <div
            className="prose prose-slate max-w-none prose-headings:font-display prose-headings:font-bold prose-headings:uppercase prose-headings:tracking-wide prose-h1:text-3xl prose-h2:text-2xl prose-h3:text-xl prose-p:text-slate-600 prose-p:leading-relaxed prose-strong:text-[#111111] prose-strong:font-bold prose-a:text-brand-orange prose-a:no-underline hover:prose-a:underline"
            dangerouslySetInnerHTML={{ __html: pageData.content }}
          />
        </div>

        {/* Sidebar / Image Column */}
        <div className="lg:col-span-5 space-y-8">
          <div className="relative">
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=80,format=auto/assets/c68264d9-2499-44ef-9e49-6b5cd7a6c3b2/hero-bg-1-1347.jpg"
              alt="Benjamin A. W. Petersen"
              className="rounded-none shadow-none border border-slate-200 w-full object-cover h-[300px] md:h-[400px]"
            />
            <div className="absolute -bottom-6 -left-6 bg-[#222222] text-white p-6 rounded-none shadow-none border-l-4 border-brand-orange max-w-xs">
              <span className="font-display font-extrabold text-lg block mb-1 text-brand-orange uppercase tracking-wide">Benjamin Petersen</span>
              <span className="text-xs font-semibold text-slate-300">Ejer, uddannet tømrer &amp; byggetekniker</span>
            </div>
          </div>

          {/* Core Values Box */}
          <div className="bg-slate-50 p-8 rounded-none border border-slate-200 space-y-6 mt-12">
            <h3 className="font-display font-bold text-lg text-[#111111] uppercase tracking-wider">
              Vores Garanti
            </h3>
            <ul className="space-y-4 text-sm text-slate-700">
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-check text-brand-orange mt-1 shrink-0"></i>
                <span>Førsteklasses håndværk udført efter alle kunstens regler.</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-check text-brand-orange mt-1 shrink-0"></i>
                <span>Tæt dialog og gennemskuelighed gennem hele byggeprocessen.</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-check text-brand-orange mt-1 shrink-0"></i>
                <span>Overholdelse af alle aftaler, tidsplaner og priser.</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-check text-brand-orange mt-1 shrink-0"></i>
                <span>En tømrer, der tager sig tid til dig og dine behov.</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

    </div>
  )
}
